import ParticleMaterial from "../../rendering/star/particle-material";

class Particles extends THREE.Points {
    constructor({ star, temperature }) {
        const geometry = new THREE.BufferGeometry();
        // Define attributes of the instancing geometry
        const num = 1200;
        const baPositions = new THREE.BufferAttribute(new Float32Array(num * 3), 3);
        const baDelay = new THREE.BufferAttribute(new Float32Array(num), 1, 1);
        const baSpeed = new THREE.BufferAttribute(new Float32Array(num), 1, 1);
        for (let i = 0, ul = num; i < ul; i++) {
            const radian1 = THREE.Math.DEG2RAD * (randomArbitrary(0, 150) - 75);
            const radian2 = THREE.Math.DEG2RAD * randomArbitrary(0, 360);
            const radius = Math.random() * Math.random() * 8 + 6;
            const spherical = getSphericalPosition(radian1, radian2, radius);
            baPositions.setXYZ(i, spherical[0], spherical[1], spherical[2]);
            baDelay.setXYZ(i, Math.random());
            baSpeed.setXYZ(i, randomArbitrary(5, 10) * (randomInt(0, 1) * 2.0 - 1.0));
        }
        geometry.addAttribute('position', baPositions);
        geometry.addAttribute('delay', baDelay);
        geometry.addAttribute('speed', baSpeed);

        const material = new ParticleMaterial({ temperature });

        super(geometry, material);

        this.type = "Particles";
        this.overridePicker = star;
    }

    update(time) { this.material.uniforms.time.value = time; }
}

export default Particles;
export { Particles };

function randomArbitrary(min, max) { return Math.random() * (max - min) + min; }
function randomInt(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
function getSphericalPosition(radian1, radian2, radius) {
    return [
        Math.cos(radian1) * Math.cos(radian2) * radius,
        Math.sin(radian1) * radius,
        Math.cos(radian1) * Math.sin(radian2) * radius,
    ];
}